import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-panel-eventos',
  templateUrl: './panel-eventos.component.html',
  styleUrls: ['./panel-eventos.component.scss']
})

export class PanelEventosComponent implements OnInit {

  @Input() eventos : any = [];

  constructor() { }

  ngOnInit(): void {
  }

}
